module.exports = __webpack_public_path__ + "img/icon_download.93e40bf7.svg";